<template>
  <a class="library__card card" :href="decode(doc.url)">
    <div class="card__logo-container">
      <div class="card__logo-wrapper">
        <div class="card__logo h-center-align">
          <span class="glyphicon glyphicon-file" aria-hidden="true"></span>
        </div>
      </div>
    </div>
    <div class="card__title">
      {{ doc.title }}
    </div>
    <div class="card__description">
      Uploaded on {{ doc.created_time }}
    </div>
  </a>
</template>

<script>
  import FuelUtilities from "../../utils/FuelUtilities.js";

  export default {
    name: 'EdgeCard',
    mixins: [FuelUtilities],
    props: {
      doc: Object,
    },
  };
</script>
